<template>
<m-pageframe
  title="Conversation Not Found"
  color="error"
>
<v-container
>
    <v-card
        style="max-width: 600px; margin: 0 auto"
    >
        <v-card-title>Unable to find the specified conversation</v-card-title>
        <v-card-subtitle>
            
            <p>
                RedChirp was unable to load the conversation with the following id:
            </p>
            
            <p>
                <code>
                    {{$route.params.conversation_id}}
                </code>
            </p>

            <p>
                Clicking the "continue" button below will reload your conversations page -- this should correct the error.
            </p>

        </v-card-subtitle>

        <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="primary darken-1"
            text
            @click="goHome"
        >
        Continue
        </v-btn>
    </v-card-actions>
    </v-card>
</v-container>
</m-pageframe>
</template>

<script>
export default {
    methods: {
        goHome() 
        {
            this.$router.push({'name': 'home'}).catch(e=>{}); // swallow any exception
        }
    },
}
</script>

<style lang="scss" scoped>

</style>